export default "__VITE_ASSET__kWpTL_ZQ__"